import QuantityOption from 'components/accessories-page/quantity-option';
import ControlHitArea from 'components/inputs/control-hit-area';
import type {
  AccessoryOptionGroupType,
  AccessoryOptionType
} from 'utils/accessory-option-groups-types';

type AccessoryOptionGroupProps = {
  group: AccessoryOptionGroupType;
  quantitySelection: boolean;
  radioGroupName: string;
  showHeading: boolean;
  onCheckboxChange: (option: AccessoryOptionType, quantity: number) => void;
  onRadioSelect: (productId: number | null) => void;
};

export default function AccessoryOptionGroup({
  group,
  quantitySelection,
  radioGroupName,
  showHeading,
  onCheckboxChange,
  onRadioSelect
}: AccessoryOptionGroupProps) {
  const noneSelected = group.options.every((option) => option.quantity < 1);
  const isSingleChoice = group.mode === 'single';

  return (
    <div className='flex flex-col'>
      {showHeading && (
        <span className='px-5 pt-3 text-xs font-semibold uppercase tracking-wide text-gray-500'>
          {group.label}
        </span>
      )}
      {group.options.map((option) => (
        <QuantityOption
          key={option.product.productId}
          accessory={option.product}
          quantity={option.quantity}
          onChange={(value) => {
            if (isSingleChoice) {
              onRadioSelect(option.product.productId);
              return;
            }
            onCheckboxChange(option, value);
          }}
          size='compact'
          recommended={option.isRecommended}
          simpleMode={!quantitySelection}
          control={isSingleChoice ? 'radio' : 'checkbox'}
          radioGroupName={radioGroupName}
          checkedQuantity={option.recommendation.recommendedQuantity ?? 1}
        />
      ))}
      {isSingleChoice && (
        <label className='flex cursor-pointer items-center p-5'>
          <ControlHitArea as='span'>
            <input
              type='radio'
              name={radioGroupName}
              aria-label='None'
              className='mr-4 h-5 w-5 cursor-pointer border-gray-300 text-blue-600'
              checked={noneSelected}
              onChange={() => onRadioSelect(null)}
            />
          </ControlHitArea>
          <span className='font-semibold text-gray-700'>None</span>
        </label>
      )}
    </div>
  );
}
